import URI from 'urijs';
import { push as rrrPush, replace as rrrReplace } from 'react-router-redux';
import { getQueryParams } from './sdk-query-params';

const appendSdkQueryParams = to => {
  if (typeof to === 'object') {
    return { ...to, query: { ...getQueryParams(), ...to.query } };
  } else {
    const url = new URI(to);
    url.search({ ...getQueryParams(), ...url.search(true) });
    return url.toString();
  }
};

export const push = to => rrrPush(appendSdkQueryParams(to));
export const replace = to => rrrReplace(appendSdkQueryParams(to));



// WEBPACK FOOTER //
// ./app/services/router-utils.js